import { CellProps } from 'react-table'
import { ImportacaoDetalhe } from '../../core/_models'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { sortableColumn, StackedCell, TableColumn } from '../../../../../../components'
import { TFunction } from '_metronic/i18n/Metronici18n'

const importacoesDetalhesColumns = (
  t: TFunction
): ReadonlyArray<TableColumn<ImportacaoDetalhe>> => [
  // Prontuário é a linha de apoio do paciente; os dois seguem ordenáveis.
  sortableColumn<ImportacaoDetalhe>({
    id: 'paciente',
    useQueryRequest,
    fields: [
      { field: 'paciente', label: t('cols.paciente') },
      { field: 'prontuario', label: t('cols.prontuario') },
    ],
    Cell: ({ row }: CellProps<ImportacaoDetalhe>) => (
      <StackedCell primary={row.original.paciente} secondary={row.original.prontuario} />
    ),
  }),
  sortableColumn<ImportacaoDetalhe>({
    id: 'atendimento',
    cellWidth: '220px',
    useQueryRequest,
    fields: [{ field: 'atendimento', label: t('cols.protocolo') }],
    Cell: ({ row }: CellProps<ImportacaoDetalhe>) => (
      <StackedCell tabular primary={row.original.atendimento} />
    ),
  }),
]

export { importacoesDetalhesColumns }
